export const normalizeCsvHeaderMapping = (mapping = {}) => {
  if (!mapping || typeof mapping !== 'object') return {}
  const normalized = { ...mapping }
  if (mapping.terminationDate && !mapping.endDate) {
    normalized.endDate = mapping.terminationDate
  }
  return normalized
}
